import styled from 'styled-components'

const fontSizeChooser = ({ theme, size }) => {
  switch (size) {
    case 'large':
      return theme.fontSize(3)
    case 'small':
      return theme.fontSize(1)
    default:
      return theme.fontSize(2)
  }
}

const backgroundChooser = ({ theme, pulse, disabled }) => {
  let gradient = theme.color.Button.bg.join(',')
  if (disabled) gradient = theme.color.Button.bgDisabled.join(',')
  if (pulse)
    gradient = theme.color.Button.bg[0] + ',' + theme.color.Button.bgHover[1]

  return `linear-gradient(to bottom, ${gradient})`
}

const FormSubmit = styled.input.attrs({
  type: 'submit',
})`
  -webkit-appearance: none;
  align-items: center;
  background: ${backgroundChooser};
  background-size: ${p => (p.pulse ? '100% 200%' : 'auto')};
  border-radius: ${props => props.theme.radius(-2)};
  border: 0.2rem solid ${p => p.theme.color.Button.border};
  box-shadow: 0.2rem -0.2rem 0 rgba(0, 0, 0, 0.5),
    inset 0 0.2rem 0
      ${props =>
        props.disabled
          ? props.theme.color.Button.shadowInsetDisabled
          : props.theme.color.Button.shadowInset};
  cursor: ${p => (p.disabled ? 'default' : 'pointer')};
  display: inline-flex;
  justify-content: center;
  letter-spacing: 0.1rem;
  margin-top: ${props => props.theme.spacing(-2)};
  padding: ${p => p.theme.spacing(-3)} ${props => props.theme.spacing(2)};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  position: relative;

  color: ${props =>
    props.disabled
      ? props.theme.color.Button.copyDisabled
      : props.theme.color.Button.copy};
  font-family: ${props => props.theme.fontFamily.primary};
  font-size: ${p => p.theme.fontSize(2.5)};
  line-height: 100%;
  text-transform: uppercase;

  &:hover {
    background: linear-gradient(
      to bottom,
      ${props =>
        props.theme.color.Button.bgHover
          ? props.theme.color.Button.bgHover.join(',')
          : props.theme.color.Button.bg.join(',')}
    );
    box-shadow: 0.2rem -0.2rem 0 rgba(0, 0, 0, 0.5),
      inset 0 0.2rem 0
        ${props =>
          props.theme.color.Button.shadowInsetHover
            ? props.theme.color.Button.shadowInsetHover
            : props.theme.color.Button.shadowInset};
  }

  &:active {
    background: linear-gradient(
      to bottom,
      ${props =>
        props.theme.color.Button.bgActive
          ? props.theme.color.Button.bgActive.join(',')
          : props.theme.color.Button.bg.join(',')}
    );
    box-shadow: 0.2rem -0.2rem 0 rgba(0, 0, 0, 0.5),
      inset 0 0.2rem 0
        ${props =>
          props.theme.color.Button.shadowInsetActive
            ? props.theme.color.Button.shadowInsetActive
            : props.theme.color.Button.shadowInset};
  }
`

export default FormSubmit



// WEBPACK FOOTER //
// ./src/components/FormSubmit.js